module.exports = __webpack_public_path__ + "static/crystalHeart-a19630de11d77e38780849e64985a75b.png";